import { FlattenTreeResult } from '~components/ui/HorizontalTreeTable/Table';

export const filterSearchTreeList = <T extends Record<string, unknown>>(
  treeList: FlattenTreeResult<T>[],
  searchTerm: string,
): FlattenTreeResult<T>[] => {
  if (!searchTerm.trim()) return treeList; // 검색어가 없으면 전체 반환

  const lowerCaseSearchTerm = searchTerm.toLowerCase();
  const matchedNodes = new Set<string>(); // 검색된 노드 ID 저장
  const parentNodes = new Set<string>(); // 부모 노드 ID 저장

  // 1. 검색어가 포함된 노드를 찾고 저장
  for (const node of treeList) {
    if (node.namePath.toLowerCase().includes(lowerCaseSearchTerm)) {
      matchedNodes.add(node.key);
      let currentParent = node.parentId;

      // 2. 부모 노드를 찾아 저장 (검색된 노드의 부모를 계속 추적)
      while (currentParent) {
        const parentNode = treeList.find((n) => n.key === currentParent);
        if (!parentNode) break;

        parentNodes.add(parentNode.key);
        currentParent = parentNode.parentId;
      }
    }
  }

  // 3. 검색된 노드 + 부모 노드만 필터링하여 반환
  return treeList.filter((node) => matchedNodes.has(node.key) || parentNodes.has(node.key));
};
